import { Injectable } from '@angular/core';
import { GenericResponse } from '../business-entities/generic-response'
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';
import { BrandModel, BrandViewModel,CompetenceByBrandResponseModel } from '../business-entities/brand-view-model';

@Injectable({
    providedIn: 'root'
})

export class BrandDataService {
    constructor(private dataProvider: DataService) {
    }

    async getBrand(): Promise<GenericResponse<Array<BrandViewModel>>> {
        return this.dataProvider.GetAll<GenericResponse<Array<BrandViewModel>>>(Urls.GetBrands).toPromise();
    }

    AddBrand(model: BrandModel): Promise<GenericResponse<any>> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.AddBrand, model).toPromise();
    }

    async GetBrandById(id: number): Promise<GenericResponse<BrandViewModel>> {
        return this.dataProvider.Get<GenericResponse<BrandViewModel>>
            (Urls.GetBrandById, id).toPromise();
    }

    EditBrand(Model: BrandModel): Promise<GenericResponse<any>> {
        return this.dataProvider.Put<GenericResponse<any>>(Urls.EditBrand, Model).toPromise();
    }

    DeleteBrand(Id: number): Promise<GenericResponse<boolean>> {
        return this.dataProvider.Delete<GenericResponse<boolean>>(Urls.DeleteBrand, Id).toPromise();
    }

    async GetCompetenceByBrandId(Id: number): Promise<GenericResponse<CompetenceByBrandResponseModel>> {
        return this.dataProvider.Get<GenericResponse<CompetenceByBrandResponseModel>>(Urls.GetCompetenceByBrandId,Id).toPromise();
    }

    async GetBrandDropdown(): Promise<any> {
        return this.dataProvider.GetAll<any>(Urls.GetBrandDropdownList).toPromise();
    }
    async GetModelnoDropdownList(brand:string): Promise<any> {
        return this.dataProvider.Get<any>(Urls.GetModelnoDropdownList,brand).toPromise();
    }
    async GetServiceBrandDropdownList(brandCode:string): Promise<any> {
        return this.dataProvider.Get<any>(Urls.GetServiceBrandDropdownList,brandCode).toPromise();
    }
}